import { defineComponent as w, ref as u, watch as O, openBlock as y, createBlock as C, unref as l, withCtx as a, createVNode as n, createElementVNode as k, toDisplayString as p, createTextVNode as h, createElementBlock as T, Fragment as V, renderList as D } from "vue";
import P from "./ghl-ui.es297.js";
import U from "./ghl-ui.es298.js";
import "./ghl-ui.es22.js";
import "./ghl-ui.es51.js";
import "./ghl-ui.es13.js";
import R from "./ghl-ui.es224.js";
import $ from "./ghl-ui.es215.js";
import _ from "./ghl-ui.es68.js";
import j from "./ghl-ui.es227.js";
import q from "./ghl-ui.es117.js";
import z from "./ghl-ui.es85.js";
import L from "./ghl-ui.es161.js";
import M from "./ghl-ui.es162.js";
const G = { class: "mr-1" }, H = { class: "flex items-center justify-between w-60 filter-heading" }, J = { class: "flex items-center text-primary-600 space-x-2 actions" }, K = w({
  name: "UIFilter",
  inheritAttrs: !1
}), Q = w({
  ...K,
  props: {
    collapseItems: {
      type: Array,
      default: () => []
    },
    options: {
      type: Array,
      default: () => []
    },
    id: {
      type: String,
      required: !0
    }
  },
  emits: ["update:filter"],
  setup(s, { emit: A }) {
    const d = s, F = A, m = u(), i = u([]), g = u(), c = u({}), v = u(0);
    O(
      () => d.options,
      (o) => {
        i.value = o;
      },
      {
        immediate: !0
      }
    );
    function I(o) {
      const t = i.value.find((e) => o.key === e.key);
      return t ? (t == null ? void 0 : t.options) || [] : [];
    }
    function N(o) {
      const t = i.value.find((e) => o.key === e.key);
      return t ? (t == null ? void 0 : t.value) || "" : [];
    }
    function B(o, t) {
      const e = U(i.value);
      e.forEach((r) => (r.key === t.key && (r.value = o), r)), i.value = e, m.value = U(e).map((r) => (delete r.options, r)), c.value[t.key] = o;
    }
    function S() {
      i.value = d.options, m.value = {}, c.value = {}, b(), x();
    }
    function b() {
      v.value = 0;
      for (const o in c.value) {
        const t = c.value[o], e = d.options.find((r) => r.key === o);
        e.key === o && e.value !== t && (v.value += 1);
      }
      F("update:filter", {
        filters: m.value,
        options: i.value
      });
    }
    function E() {
      b(), x();
    }
    function x() {
      g.value.handleClick();
    }
    const f = R("DataTable");
    return (o, t) => (y(), C(l($), {
      trigger: "click",
      "show-arrow": !1,
      ref_key: "popoverRef",
      ref: g,
      placement: "bottom"
    }, {
      trigger: a(() => [
        n(l(_), {
          size: "large",
          class: "hl-table-filter-btn",
          id: ""
        }, {
          default: a(() => [
            n(l(P), { class: "w-5 h-5 mr-1" }),
            k("span", G, p(l(f).filters), 1),
            n(l(j), {
              class: "badge",
              value: v.value,
              color: "#F2F4F7"
            }, null, 8, ["value"])
          ]),
          _: 1
        })
      ]),
      header: a(() => [
        k("div", H, [
          n(l(q), { class: "title text-gray-900" }, {
            default: a(() => [
              h(p(l(f).filters), 1)
            ]),
            _: 1
          }),
          k("div", J, [
            n(l(_), {
              text: "",
              onClick: S,
              id: `hl-table-${s.id}-filter-clear`
            }, {
              default: a(() => [
                h(p(l(f).clear), 1)
              ]),
              _: 1
            }, 8, ["id"]),
            n(l(_), {
              text: "",
              onClick: E,
              id: `hl-table-${s.id}-filter-apply`
            }, {
              default: a(() => [
                h(p(l(f).apply), 1)
              ]),
              _: 1
            }, 8, ["id"])
          ])
        ])
      ]),
      default: a(() => [
        n(l(L), null, {
          default: a(() => [
            (y(!0), T(V, null, D(s.collapseItems, (e) => (y(), C(l(M), {
              title: e.label,
              name: e.key,
              key: e.key
            }, {
              default: a(() => [
                n(l(z), {
                  options: I(e),
                  value: N(e),
                  id: s.id,
                  "onUpdate:value": (r) => B(r, e)
                }, null, 8, ["options", "value", "id", "onUpdate:value"])
              ]),
              _: 2
            }, 1032, ["title", "name"]))), 128))
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 512));
  }
}), ce = Q;
export {
  ce as default
};
